import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Accueil } from './pages/Accueil.js';
import { CommentCaMarche } from './pages/CommentCaMarche.js';
import { Confidentialite } from './pages/Confidentialite.js';
import { Faq } from './pages/Faq.js';
import { Inscription } from './pages/Inscription.js';
import { MentionsLegales } from './pages/MentionsLegales.js';
import { Onboarding } from './pages/Onboarding/index.js';
import { Tarifs } from './pages/Tarifs.js';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/comment-ca-marche" element={<CommentCaMarche />} />
        <Route path="/tarifs" element={<Tarifs />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
      </Routes>
    </BrowserRouter>
  );
}
